export const aiIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<rect width="32" height="32" rx="8" fill="url(#paint0_linear_774_3384)" />
		<path
			d="M21.4235 17.7691C17.6518 19.0152 16.3959 20.2714 15.1498 24.0429C15.0472 24.353 14.6088 24.353 14.5063 24.0429C13.2602 20.2712 12.004 19.0153 8.23255 17.7691C7.92248 17.6666 7.92248 17.2282 8.23255 17.1257C12.0042 15.8796 13.2602 14.6234 14.5063 10.8519C14.6088 10.5419 15.0473 10.5419 15.1498 10.8519C16.3958 14.6236 17.6521 15.8796 21.4235 17.1257C21.7336 17.2282 21.7336 17.6666 21.4235 17.7691Z"
			fill="white"
		/>
		<path
			d="M24.1579 11.5753C22.2725 12.1979 21.6441 12.8264 21.0206 14.7126C20.9698 14.8676 20.7506 14.8676 20.6989 14.7126C20.0763 12.8272 19.4478 12.1988 17.5616 11.5753C17.4066 11.5245 17.4066 11.3053 17.5616 11.2536C19.447 10.6309 20.0754 10.0025 20.6989 8.11627C20.7497 7.96124 20.9689 7.96124 21.0206 8.11627C21.6433 10.0017 22.2717 10.6301 24.1579 11.2536C24.313 11.3044 24.313 11.5236 24.1579 11.5753Z"
			fill="white"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_774_3384"
				x1="16"
				y1="0"
				x2="16"
				y2="32"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#7351FD" />
				<stop offset="1" stop-color="#A33BFF" />
			</linearGradient>
		</defs>
	</svg>
);

export const generateIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
	>
		<path
			d="M13.9235 10.4935C10.1518 11.7396 8.89589 12.9958 7.64976 16.7673C7.54724 17.0773 7.1088 17.0773 7.0063 16.7673C5.76021 12.9956 4.50401 11.7396 0.732545 10.4935C0.422485 10.391 0.422485 9.95255 0.732545 9.85005C4.50422 8.60396 5.76017 7.34776 7.0063 3.5763C7.10882 3.26623 7.54725 3.26623 7.64976 3.5763C8.89585 7.34797 10.1521 8.60392 13.9235 9.85005C14.2336 9.95257 14.2336 10.391 13.9235 10.4935Z"
			fill="white"
		/>
		<path
			d="M16.6579 4.29967C14.7725 4.92231 14.1441 5.55078 13.5206 7.43698C13.4698 7.59201 13.2506 7.59201 13.1989 7.43698C12.5763 5.55159 11.9478 4.92317 10.0616 4.29967C9.90655 4.24883 9.90655 4.02962 10.0616 3.97794C11.947 3.3553 12.5754 2.72684 13.1989 0.840639C13.2497 0.685607 13.4689 0.685607 13.5206 0.840639C14.1433 2.72603 14.7717 3.35445 16.6579 3.97794C16.813 4.02879 16.813 4.24799 16.6579 4.29967Z"
			fill="white"
		/>
	</svg>
);

export const upgradeIcon = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="20" height="20" rx="6" fill="#FF3A52" />
		<path
			d="M9.40042 9.59935C9.36441 9.58975 9.33321 9.58135 9.30081 9.57415C9.15539 9.55129 9.02412 9.47395 8.93363 9.35784C8.84315 9.24172 8.80023 9.09553 8.8136 8.94893C8.82464 8.79839 8.89303 8.65781 9.00467 8.55622C9.11632 8.45462 9.2627 8.39975 9.41362 8.40292C9.58402 8.40292 9.75562 8.41372 9.92483 8.40292C10.2572 8.37652 10.586 8.60692 10.5824 9.06294C10.5824 9.60055 10.5824 10.143 10.5824 10.6758C10.5824 11.2086 10.5824 11.7426 10.5824 12.2754C10.5824 12.3126 10.5824 12.3498 10.5824 12.3954L10.6904 12.4194C10.8357 12.4459 10.9659 12.5256 11.0554 12.6429C11.145 12.7602 11.1876 12.9068 11.1749 13.0539C11.1621 13.201 11.0949 13.338 10.9865 13.4382C10.878 13.5383 10.7361 13.5944 10.5884 13.5954C10.1884 13.6018 9.78843 13.6018 9.38842 13.5954C9.24062 13.5974 9.09745 13.5439 8.98709 13.4456C8.87674 13.3473 8.80719 13.2112 8.79214 13.0641C8.77709 12.9171 8.81763 12.7697 8.90577 12.6511C8.99392 12.5324 9.12329 12.4511 9.26841 12.423C9.30441 12.4146 9.34161 12.4086 9.38842 12.399V9.59935H9.40042Z"
			fill="white"
		/>
		<path
			d="M9.00782 7.19481C9.01126 6.98395 9.09704 6.78279 9.24684 6.63435C9.39663 6.4859 9.59855 6.40193 9.80944 6.40039C10.0174 6.40633 10.2149 6.49314 10.3599 6.64239C10.5049 6.79163 10.5859 6.99154 10.5859 7.19961C10.5855 7.30323 10.5648 7.40577 10.5249 7.50137C10.4849 7.59698 10.4266 7.68378 10.3531 7.75683C10.2796 7.82987 10.1924 7.88773 10.0966 7.92709C10.0007 7.96645 9.89805 7.98655 9.79444 7.98623C9.69082 7.98592 9.58828 7.96519 9.49267 7.92525C9.39707 7.88531 9.31026 7.82693 9.23722 7.75343C9.16417 7.67994 9.10632 7.59279 9.06696 7.49694C9.0276 7.40109 9.0075 7.29843 9.00782 7.19481Z"
			fill="white"
		/>
		<path
			d="M10.0194 4.00003C13.3135 4.01083 16.0196 6.7193 16.0004 9.99058C15.9994 10.7807 15.8429 11.563 15.5396 12.2926C15.2363 13.0223 14.7923 13.685 14.233 14.2431C13.6736 14.8012 13.0097 15.2436 12.2794 15.5451C11.549 15.8466 10.7664 16.0013 9.97622 16.0003C6.67973 16.0063 3.98447 13.2775 4.00007 9.94738C4.01401 8.36188 4.65495 6.84635 5.78284 5.73195C6.91073 4.61756 8.43386 3.9949 10.0194 4.00003ZM10.047 5.13526C9.40581 5.12907 8.76974 5.25009 8.17559 5.4913C7.58145 5.73252 7.04104 6.08915 6.58561 6.54056C6.13018 6.99197 5.76878 7.52921 5.52231 8.12119C5.27584 8.71317 5.14919 9.34814 5.1497 9.98938C5.1197 12.6402 7.31935 14.8531 9.97742 14.8591C10.6185 14.8605 11.2535 14.7351 11.8458 14.4899C12.4382 14.2448 12.9761 13.8848 13.4287 13.4308C13.8813 12.9768 14.2395 12.4377 14.4828 11.8446C14.726 11.2514 14.8494 10.616 14.8459 9.97498C14.8303 7.31692 12.6703 5.13886 10.047 5.13526Z"
			fill="white"
		/>
	</svg>
);
